// src/snackbar.utils.ts
function findSnackbar(snackbars, id) {
  const position = getSnackbarPosition(snackbars, id);
  const index = position ? snackbars[position].findIndex((snackbar) => snackbar.id === id) : -1;
  return {
    position,
    index
  };
}
var getSnackbarPosition = (snackbars, id) => {
  var _a;
  return (_a = Object.values(snackbars).flat().find((snackbar) => snackbar.id === id)) == null ? void 0 : _a.position;
};
function getSnackbarStyle(position) {
  const isRighty = position.includes("right");
  const isLefty = position.includes("left");
  let alignItems = "center";
  if (isRighty)
    alignItems = "flex-end";
  if (isLefty)
    alignItems = "flex-start";
  return {
    display: "flex",
    flexDirection: "column",
    alignItems
  };
}
function getSnackbarElevation(position) {
  const isRighty = position.includes("right");
  const isLefty = position.includes("left");
  const elevation = isRighty ? "right" : isLefty ? "left" : "center";
  return elevation;
}
function getSnackbarListStyle(position) {
  const isTopOrBottom = position === "top" || position === "bottom";
  const margin = isTopOrBottom ? "0 auto" : void 0;
  const top = position.includes("top") ? `calc(env(safe-area-inset-top, 0px) + 2rem)` : void 0;
  const bottom = position.includes("bottom") ? `calc(env(safe-area-inset-bottom, 0px) + 2rem)` : void 0;
  const right = !position.includes("left") ? `calc(env(safe-area-inset-right, 0px) + 3.5rem)` : void 0;
  const left = !position.includes("right") ? `calc(env(safe-area-inset-left, 0px) + 3.5rem)` : void 0;
  return {
    position: "fixed",
    zIndex: "var(--snackbar-z-index, 5500)",
    pointerEvents: "none",
    display: "flex",
    flexDirection: "column",
    margin,
    top,
    bottom,
    right,
    left
  };
}

export {
  findSnackbar,
  getSnackbarPosition,
  getSnackbarStyle,
  getSnackbarElevation,
  getSnackbarListStyle
};
